import React, { Component } from "react";

import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/action/home';

import "../CSS/style_SGButton.css";

export default class SGButton extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    var props = this.props;
    var tooltip         = props.tooltip         || "";
    var tooltipPosition = props.tooltipPosition || "top-center";
    var icon            = props.icon            || <ActionHome />;
    var disabled        = props.disabled        || false;
    var onClick         = props.onClick         || null;

    return (
      <IconButton
        className       = "sg-button"
        tooltip         = { tooltip         }
        tooltipPosition = { tooltipPosition }
        disabled        = { disabled        }
        onClick         = { onClick         }
      >
        {icon}
      </IconButton>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_SGButton.js